import { BroadcastInsights } from 'types'
import axios from 'api/axios'

export interface GetBroadcastsInsightsParams {
	broadcast?: string
	client?: string
}

export interface GetBroadcastsInsightsResponse {
	insights: BroadcastInsights
}

const getBroadcastsInsights = async (
	params: GetBroadcastsInsightsParams
): Promise<GetBroadcastsInsightsResponse> => {
	const response = await axios.get<GetBroadcastsInsightsResponse>(
		`v1/broadcast/management/insight/all`,
		{
			params,
		}
	)

	return response.data
}

export default getBroadcastsInsights
